import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { history } from './utils/history';
import NoMatchPage from './pages/NoMatchPage';
import QrLayout from './layout/QrLayout';
import MailVerifyPage from './pages/MailVerifyPage';
import InquaryPage from './pages/InquaryPage';
import CameraPage from './pages/CameraPage';
import PassForgotPage from './pages/PassForgotPage';
import PrivateAnlagenPage from './pages/customer/AnlagenPage';
import HwDashLayout from './layout/HwDashLayout'
import LeerstandPage from './pages/hw/LeerstandPage';
import LogoutPage from './pages/LogoutPage';
import CustomerDashLayout from './layout/CustomerDashLayout';
import TimeLinePage from './pages/customer/TimeLinePage';
import AnlagenPage from './pages/hw/AnlagenPage';
import SupportPage from './pages/SupportPage';
import QrPage from './pages/QrPage';
import HomePage from './pages/HomePage';
import AnmeldenPage from './pages/customer/AnmeldenPage';
import { AuthProvider } from './context/AuthContext';
import HwGuard from './guards/HwGuard';
import PrivateGuard from './guards/PrivateGuard';
import DashboardPage from './pages/hw/DashboardPage';
import ScanPage from './pages/hw/ScanPage';
import BuildingsPage from './pages/hw/BuildingsPage';
import ElvPage from './pages/private/ElvPage';
import ElvDetailPage from './pages/private/ElvDetailPage';
import InvoicePage from './pages/hw/InvoicePage';
import ProfilePage from './pages/private/ProfilePage';
import DownloadPage from './pages/private/DownloadPage';
import ArchivePage from './pages/hw/ArchivePage';
import LoggedPage from './pages/LoggedPage';
import BuildingAnlagenPage from './pages/hw/BuildingAnlagenPage';
import ReactGA from "react-ga4";
import NewTicketPage from './pages/NewTicketPage';
import HwTimelinePage from './pages/hw/HwTimelinePage';
import NotificationPage from './pages/private/NotificationPage';
import NotificationDetailsPage from './pages/private/NotificationDetailsPage';
import PromoVideoPage from './pages/PromoVideoPage';
import NewBuildingPage from './pages/hw/NewBuildingPage';
import FaqPage from './pages/private/FaqPage';
import PrivateDashboardPage from './pages/private/PrivateDashboardPage';
import VollmachtSignPage from './pages/VollmachtSignPage';
import MissingDocumentUnsubPage from './pages/MissingDocumentUnsubPage';
import WillkommenPage from './pages/WillkommenPage';

// App
function App() {
  
  // Google Analytics
  if (window.location.hostname === 'mein.energiepool.at') {
	  const TRACKING_ID = "G-LWLH6PYV7Y";
	  ReactGA.initialize(TRACKING_ID);
  }

  history.navigate = useNavigate();
  history.location = useLocation();

  //const { authenticated, user } = useAuthState();
  //const dispatch = useAuthDispatch();


  return (
    <AuthProvider>
      <Routes>
        <Route path='/'>
          <Route index element={<HomePage />} />
          <Route path='willkommen/' element={<WillkommenPage />} />
          <Route path='jahresabrechnung/:token' element={<HomePage />} />
          <Route path='login/:next' element={<HomePage />} />
          <Route path='logged/' element={<LoggedPage />} />
          <Route path='password/reset/:token' element={<PassForgotPage />} />
          <Route path='mail/confirmation/:token' element={<MailVerifyPage />} />
          <Route path='registration/' element={<InquaryPage />} />
          <Route path="vollmacht/" element={<VollmachtSignPage />} />
          <Route path="unsubscribe/:token" element={<MissingDocumentUnsubPage />} />
        </Route>
        <Route path='/qr/' element={<QrLayout />}>
          <Route index element={<QrPage />} />
          <Route path=':qr' element={<QrPage />} />
          <Route path='camera/' element={<CameraPage />} />
        </Route>

        <Route path='/dashboard/' element={<CustomerDashLayout />}>
          <Route index element={<PrivateGuard Component={PrivateDashboardPage} />} />
          <Route path='zeitverlauf/' element={<PrivateGuard Component={TimeLinePage} />} />
          <Route path='zeitverlauf/:anlage' element={<PrivateGuard Component={TimeLinePage} />} />
          <Route path='anlagen/' element={<PrivateGuard Component={PrivateAnlagenPage} />} />
          <Route path='anlagen/anmelden/' element={<PrivateGuard Component={AnmeldenPage} />} />
          <Route path='energieliefervertraege/:elv_id' element={<PrivateGuard Component={ElvDetailPage}/>}/>
          <Route path='support/' element={<PrivateGuard Component={SupportPage} />} />
          <Route path='support/:ticket_id' element={<PrivateGuard Component={SupportPage} />} />
          <Route path='support/neu/' element={<PrivateGuard Component={NewTicketPage}/>} />
          <Route path='support/neu/:param' element={<PrivateGuard Component={NewTicketPage}/>} />
          <Route path='profile/' element={<PrivateGuard Component={ProfilePage} />} />
          <Route path='neuedokumente/' element={<PrivateGuard Component={DownloadPage} />} />
          <Route path='archive/' element={<PrivateGuard Component={ArchivePage} />} />
          <Route path='news/' element={<PrivateGuard Component={NotificationPage} />} />
          <Route path='news/details/' element={<PrivateGuard Component={NotificationDetailsPage} />} />
          <Route path="news/details/:notification_id/" element={<PrivateGuard Component={NotificationDetailsPage} />} />
          <Route path='faq/' element={<PrivateGuard Component={FaqPage} />} />
        </Route>

        <Route path={'/hw/dashboard/'} element={<HwDashLayout />}>
          <Route index element={<HwGuard Component={DashboardPage} />} />
          <Route path='anlagen/' element={<HwGuard Component={AnlagenPage} />} />
          <Route path='anlagen/top/' element={<HwGuard Component={LeerstandPage} />} />
          <Route path='gebaeude/' element={<HwGuard Component={BuildingsPage} />} />
          <Route path='gebaeude/anlagen/:building_id/' element={<HwGuard Component={BuildingAnlagenPage} />} />
          <Route path='gebaeude/dokumente/:building_id' element={<HwGuard Component={InvoicePage} />} />
          <Route path='gebaeude/neu/' element={<HwGuard Component={NewBuildingPage} />} />
          <Route path='profile/' element={<HwGuard Component={ProfilePage} />} />
          <Route path='download/' element={<HwGuard Component={DownloadPage} />} />
          <Route path="archive/" element={<HwGuard Component={ArchivePage} />} />
          <Route path="benachrichtigung/" element={<HwGuard Component={NotificationPage} /> } />
          <Route path="benachrichtigung/details/" element={<HwGuard Component={NotificationDetailsPage} />} />
          <Route path="benachrichtigung/details/:notification_id/" element={<HwGuard Component={NotificationDetailsPage} />} />
          <Route path="benachrichtigung/details/:notification_id/:secret" element={<HwGuard Component={NotificationDetailsPage} />} />
          <Route path='faq/' element={<HwGuard Component={FaqPage} />} />


          <Route path="energieliefervertraege/" element={<HwGuard Component={ElvPage} />} />
          <Route path="energieliefervertraege/:elv_id" element={<HwGuard Component={ElvDetailPage} />} />
          <Route path='energieliefervertraege/gebaeude/:buildingId' element={<HwGuard Component={ElvPage} />} />
          <Route path='energieliefervertraege/zeitverlauf/:building_id' element={<HwGuard Component={HwTimelinePage} />} />
          <Route path='energieliefervertraege/zeitverlauf/:building_id/:anlage_id' element={<HwGuard Component={HwTimelinePage} />} />
          

          <Route path='scannen/' element={<HwGuard Component={ScanPage} />} />
          <Route path='support/' element={<HwGuard Component={SupportPage} />} /> 
          <Route path='support/:ticket_id' element={<HwGuard Component={SupportPage} />} /> 
          <Route path='support/neu/' element={<HwGuard Component={NewTicketPage}/>} />
          <Route path='support/neu/:param' element={<HwGuard Component={NewTicketPage}/>} />
        </Route>
        
        <Route path="test/" element={<CameraPage />} />
        <Route path='promo/' element={<PromoVideoPage />} />
        <Route path='logout/' element={<LogoutPage />} />
        <Route path='*' element={<NoMatchPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;